import store from "../../store";

export default function () {
    if (store.state.initialized === false) {
        store.dispatch('applicationInitialize');
    }
}